import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { timeoutDelay } from '@constants/timeoutDelay';

import { apiClient } from '@services/apiClient';
import { templatesListKey } from '@services/useTemplatesListQuery';

import type { IApiError, IMutationTemplateResponse, IUpdateTemplateData } from '../model/templateMutations';
import { equipmentSettingsLogListKey } from './useEquipmentSettingsLogListInfiniteQuery';

const updateTemplateFn = (data: IUpdateTemplateData) =>
  apiClient.put(`${APP_API_URL_V2}fsd/action-item/cost-savings-settings/template`, data);

export const useUpdateTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<IMutationTemplateResponse, AxiosError<IApiError>, IUpdateTemplateData>({
    mutationFn: updateTemplateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [templatesListKey()[0]] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentSettingsLogListKey()[0]] });
      }, timeoutDelay);
    },
  });
};
